import * as Yup from "yup";

export namespace DriversFiltersNamespace {
  export interface Fields {
    driverQuery: string;
    companyDocuments: string;
  }

  export type FieldTypes = keyof typeof initialValues;
}

export const initialValues: DriversFiltersNamespace.Fields = {
  driverQuery: "",
  companyDocuments: "",
};

export const validationSchema = Yup.object().shape({
  driverQuery: Yup.string().optional(),
  companyDocuments: Yup.string()
    .email("Insira um formato válido. Ex: exemplo@gmail.com")
    .optional(),
});
